<template>
    <span
        class="od-badge"
        :class="'od-badge--' + badge.tone"
        :title="status"
    >{{ badge.label }}</span>
</template>

<script>
import { statusBadge } from './orderDetailHelpers';

export default {
    name: 'OdStatusBadge',
    props: {
        status: { type: String, default: '' },
    },
    computed: {
        badge() {
            return statusBadge(this.status);
        },
    },
};
</script>
